import { useStyles } from '@archipro-design/aria';

import { TestimonialSlide } from './TestimonialSlide';
import * as S from './Testimonials.style';

export interface SlideProps {
    Content: string;
    Source?: string | null;
}

export const TestimonialSlidePage: React.FC<{ SlideArray: SlideProps[] }> = ({
    SlideArray,
}) => {
    const { css } = useStyles();

    return (
        <div className={css(S.SlidePage)}>
            {SlideArray.map((slide, i) => {
                return (
                    <div
                        className={css(S.TestimonialSlideInner)}
                        key={'tSlide' + i}
                    >
                        <TestimonialSlide
                            content={slide.Content}
                            source={slide.Source}
                        />
                    </div>
                );
            })}
        </div>
    );
};
